import { gql } from "@apollo/client";

export const SEND_NOTIF_COORD_ASISTENCIAL = gql`
    mutation sendNotificationCoordinacionAsistencial(
        $idEvaluacion: Int!,
        $tipoNotificacionAsistencial: TipoNotificacionAsistencial!,
    ){
        sendNotificationCoordinacionAsistencial(
            input: {
                idEvaluacion: $idEvaluacion,
                tipoNotificacionAsistencial: $tipoNotificacionAsistencial,
            }
        ) 
    }
`;